module.exports = __webpack_public_path__ + "static/media/set-preferences-cta2.544dd67b.jpg";